import styled, { css } from 'styled-components';

import { IconButton } from '@speeki/icons';

export const UserResponseWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
`;

export const UserMessage = styled.div`
    align-items: center;
    display: flex;
    justify-content: flex-end;
    max-width: 555px;
    width: 100%;
`;

export const SummaryEditIcon = styled(IconButton)<{ isEditable?: boolean }>(
    ({ isEditable }) => css`
        cursor: ${isEditable ? 'pointer' : 'auto'};
        margin-right: 12px;
    `,
);
